import React from 'react';

const SectionTitle = ({ text }) => {
  return (
    <h2 
      className="glitch-text" 
      data-text={text} 
      style={styles.glitchText}
    >
      {text}
      <span style={styles.glitchBefore} aria-hidden="true">{text}</span>
      <span style={styles.glitchAfter} aria-hidden="true">{text}</span>
    </h2>
  );
};

const styles = {
  glitchText: {
    position: 'relative',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#ff0', // Neon yellow
    marginBottom: '2rem',
    textAlign: 'center',
    textTransform: 'uppercase',
    textShadow: '0 0 5px #ff0, 0 0 10px #ff0',
  },
  glitchBefore: {
    content: 'attr(data-text)',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    opacity: '0.8',
    color: '#0ff', // Cyan
    animation: 'glitch 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both infinite',
    animationDelay: '0.4s',
    clipPath: 'polygon(0 0, 100% 0, 100% 35%, 0 35%)',
    transform: 'translate(-2px, 0)',
  },
  glitchAfter: {
    content: 'attr(data-text)',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    opacity: '0.8',
    color: '#f0f', // Magenta
    animation: 'glitch 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) reverse both infinite',
    animationDelay: '0.6s',
    clipPath: 'polygon(0 65%, 100% 65%, 100% 100%, 0 100%)',
    transform: 'translate(2px, 0)',
  }
};

export default SectionTitle; 